var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgElevator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5417 3.45833V21.5417H3.45833V3.45833H21.5417ZM21.5417 0.875H3.45833C2.0375 0.875 0.875 2.0375 0.875 3.45833V21.5417C0.875 22.9625 2.0375 24.125 3.45833 24.125H21.5417C22.9625 24.125 24.125 22.9625 24.125 21.5417V3.45833C24.125 2.0375 22.9625 0.875 21.5417 0.875ZM9.91667 20.25V15.0833H11.2083V11.8542C11.2083 10.4333 10.0458 9.27083 8.625 9.27083H7.33333C5.9125 9.27083 4.75 10.4333 4.75 11.8542V15.0833H6.04167V20.25H9.91667ZM7.97917 7.97917C8.87042 7.97917 9.59375 7.25583 9.59375 6.36458C9.59375 5.47333 8.87042 4.75 7.97917 4.75C7.08792 4.75 6.36458 5.47333 6.36458 6.36458C6.36458 7.25583 7.08792 7.97917 7.97917 7.97917ZM20.25 11.2083L17.0208 6.04167L13.7917 11.2083H20.25ZM13.7917 13.7917L17.0208 18.9583L20.25 13.7917H13.7917Z",
    fill: "#C0C0C0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElevator);
export default __webpack_public_path__ + "static/media/elevator.aa67986823c6820f0f0a24ca8d1f77c2.svg";
export { ForwardRef as ReactComponent };